module.exports = __webpack_public_path__ + "static/media/stat547u_lecture10.a9f56e2d.pdf";